import { useEffect } from 'react';

/***************************  METRICS - G-TAG  ***************************/

interface Props {
  gaId: string;
}

// No visible UI for this component
export default function GTag({ gaId }: Props) {
  useEffect(() => {
    if (!gaId) {
      console.warn('Google Analytics ID is missing.');
      return;
    }

    const script1 = document.createElement('script');
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    script1.async = true;
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${gaId}');
    `;
    document.head.appendChild(script2);

    return () => {
      if (document.head.contains(script1)) document.head.removeChild(script1);
      if (document.head.contains(script2)) document.head.removeChild(script2);
    };
  }, [gaId]);

  return null;
}
